module.exports = __webpack_public_path__ + "static/img/grow0_light.3b9f7aee.png";